import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInfinityLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	color: "inherit",
	viewBox: "0 0 36 36",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#EE0C5D",
		d: "m18.84 22.268 2.132 1.973c3.436 3.422 9.018 3.417 12.448-.011A8.753 8.753 0 0 0 36 18a8.753 8.753 0 0 0-2.58-6.229c-3.428-3.429-9.012-3.434-12.448-.01l-9.225 9.191a4.174 4.174 0 0 1-5.887-.005 4.173 4.173 0 0 1 0-5.891 4.156 4.156 0 0 1 2.946-1.218c1.068 0 2.13.404 2.941 1.211l2.043 2.203 3.293-3.275-2.06-2.218c-3.434-3.422-9.018-3.417-12.447.011-3.435 3.434-3.435 9.023 0 12.459a8.783 8.783 0 0 0 6.229 2.575 8.778 8.778 0 0 0 6.218-2.563l9.226-9.192a4.174 4.174 0 0 1 5.887.005A4.138 4.138 0 0 1 31.356 18a4.144 4.144 0 0 1-1.22 2.947 4.173 4.173 0 0 1-5.887.005l-2.122-1.961-3.289 3.276.002.002Z"
	})
});
export default SvgInfinityLogo;
